import SectionHeader from "../../../../components/SectionHeader/SectionHeader.tsx";
import type { LifecycleController } from "../useLifecycle.ts";
import { BlankPicker } from "./BlankPicker.tsx";
import { CARD } from "./shared.tsx";

export function InstallmentsPanel({
  controller,
}: {
  controller: LifecycleController;
}) {
  const { schedule, policy, paymentBlankForm, paid, canPay, pay, can } =
    controller;
  if (!schedule || !policy) return null;
  return (
    <fieldset className={CARD}>
      <SectionHeader title="Вноски" />
      <div className="p-3 pt-2">
        {schedule.note && (
          <p className="mb-2 text-xs text-warning">{schedule.note}</p>
        )}
        {schedule.completeness === "unpaid-only" && (
          <p className="mb-2 text-xs text-warning">
            Показват се само върнатите неплатени вноски.
          </p>
        )}
        {can("installments.payment") &&
          policy.provider !== "dzi" &&
          schedule.installments.some(
            (row) => row.status === "due" && !paid(row)
          ) && (
            <div className="mb-3">
              <p className="mb-2 text-sm">
                {policy.provider === "levins"
                  ? "Стикерът е задължителен за отчитане на плащане (поне 6 знака)."
                  : policy.provider === "generali"
                  ? "Бланки по избор: попълнете стикер, серия и номер на сертификат заедно."
                  : "Бланки за плащането (по избор)."}
              </p>
              <BlankPicker form={paymentBlankForm} />
            </div>
          )}
        {schedule.installments.length === 0 ? (
          <p className="text-sm">Няма върнати вноски.</p>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr>
                <th scope="col" className="text-left">
                  Вноска
                </th>
                <th scope="col" className="text-left">
                  Падеж
                </th>
                <th scope="col" className="text-left">
                  Сума
                </th>
                <th scope="col" className="text-right">
                  Плащане
                </th>
              </tr>
            </thead>
            <tbody>
              {schedule.installments.map((row, index) => (
                <tr
                  key={`${row.sequence}-${row.dueDate}`}
                  className="border-t border-stroke dark:border-strokedark"
                >
                  <td className="py-2">{row.sequence}</td>
                  <td>{row.dueDate ?? "—"}</td>
                  <td className="font-semibold">
                    {row.amount.eur.toFixed(2)} EUR /{" "}
                    {row.amount.bgn.toFixed(2)} лв.
                  </td>
                  <td className="text-right">
                    {row.status === "paid" || paid(row) ? (
                      <span className="text-success">Платена</span>
                    ) : row.status !== "due" ? (
                      <span>Непотвърден статус</span>
                    ) : can("installments.payment") ? (
                      <button
                        type="button"
                        onClick={() => pay(index)}
                        disabled={!canPay(row)}
                        className="rounded bg-success px-3 py-1 text-xs text-white disabled:opacity-50"
                      >
                        Отчети плащане
                      </button>
                    ) : (
                      "—"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </fieldset>
  );
}
